// preferences.js

import { getFirestore, doc, getDoc, setDoc } from "firebase/firestore";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { ref, watch } from "vue";

const defaultPreferences = {
  colormap: "Rainbow",
  favoritePrecincts: [],
};

const preferences = ref({ ...defaultPreferences }); // Store preferences

// Function to fetch preferences from Firestore
async function fetchPreferences(user) {
  try {
    const db = getFirestore(); // Initialize Firestore once

    const userPreferencesRef = doc(db, "userPreferences", user.uid);
    const docSnap = await getDoc(userPreferencesRef);

    if (docSnap.exists()) {
      preferences.value = JSON.parse(JSON.stringify(docSnap.data()));
      if (!preferences.value.name) preferences.value.name = user.displayName;
      // Object assign didn't copy arrays correctly.
      // Object.assign(preferences, docSnap.data());
    } else {
      // If preferences don't exist, create a new document with default values

      await setDoc(userPreferencesRef, {
        ...defaultPreferences,
        email: user.email,
        name: user.displayName,
      });
    }
  } catch (error) {
    console.error("Error fetching or creating preferences:", error);
  }
}

async function toggleFavoritePrecinct(precinctId) {
  try {
    const index = preferences.value.favoritePrecincts.indexOf(precinctId);

    if (index > -1) {
      // Precinct exists, remove it
      preferences.value.favoritePrecincts.splice(index, 1);
    } else {
      // Precinct doesn't exist, add it
      preferences.value.favoritePrecincts.push(precinctId);
    }

    // Save the updated preferences to Firestore
    await savePreferences();
    console.log("Favorite precincts updated successfully!");
  } catch (error) {
    console.error("Error updating favorite precincts:", error);
  }
}

// Function to save preferences to Firestore
async function savePreferences() {
  try {
    const db = getFirestore(); // Initialize Firestore once
    const auth = getAuth(); // Initialize firestore auth

    const user = auth.currentUser;
    const userPreferencesRef = doc(db, "userPreferences", user.uid);

    await setDoc(userPreferencesRef, { ...preferences.value }); // Save current preferences

    console.log("Preferences saved successfully!");
  } catch (error) {
    console.error("Error saving preferences:", error);
  }
  applyDarkMode();
}

function initializePreferences() {
  const auth = getAuth(); // Initialize firestore auth

  // Initialize preferences when the user logs in
  onAuthStateChanged(auth, (user) => {
    if (user) {
      fetchPreferences(user);
    }
  });
  applyDarkMode();
}

// Function to apply/remove dark mode class
const applyDarkMode = () => {
  if (preferences.value.darkMode) {
    document.body.setAttribute("data-bs-theme", "dark");
  } else {
    document.body.setAttribute("data-bs-theme", "light");
  }
};

// Watch for changes in preferences.darkMode
watch(
  () => preferences.value.darkMode,
  (newDarkModeValue) => {
    applyDarkMode(newDarkModeValue);
  }
);

export {
  initializePreferences,
  preferences,
  fetchPreferences,
  savePreferences,
  toggleFavoritePrecinct,
};
